import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { Alert, Box, Button, CircularProgress } from "@mui/material";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { getSaveTheDateBySlug } from "../../utils/saveTheDatesApi";
import { formatMkPrimaryDate } from "../Invitations/invitationDateUtils";
import { useAuth } from "../../contexts/AuthContext";
import "./SaveTheDates.css";

const resolveImageUrl = (entity, key) =>
  entity?.[`${key}_image_url`] || entity?.[`${key}_url`] || "";

const SaveTheDatePublicPage = () => {
  const { slug } = useParams();
  const { authPayload } = useAuth();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await getSaveTheDateBySlug(slug);
        if (!cancelled) {
          setItem(data);
        }
      } catch (err) {
        if (!cancelled) {
          setError("Не можеме да го вчитаме Save the Date.");
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [slug]);

  const eventDate = useMemo(
    () => (item?.event_date ? new Date(item.event_date) : null),
    [item?.event_date]
  );

  const primaryDate = useMemo(() => formatMkPrimaryDate(eventDate), [eventDate]);
  const coverImage = resolveImageUrl(item, "cover");
  const footerImage = resolveImageUrl(item, "footer");
  const locationText = item?.location || item?.venue_name || "";
  const isSignedIn = Boolean(authPayload?.id_token);
  const calendarIcsUrl = `${process.env.REACT_APP_API_BASE}/save-the-dates/${encodeURIComponent(
    slug || ""
  )}/calendar.ics`;

  if (loading) {
    return (
      <Box className="fw-invitation-loading">
        <CircularProgress color="inherit" />
      </Box>
    );
  }

  if (error) {
    return (
      <Box className="fw-invitation-loading">
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  if (!item) {
    return null;
  }

  return (
    <div className="std-public-page">
      <section className="std-public-cover">
        {coverImage ? (
          <img src={coverImage} alt={item.title || "Save The Date"} />
        ) : null}
      </section>

      <section className="std-public-hero">
        <div className="std-public-hero-inner">
          <div className="std-public-eyebrow">Save The Date</div>
          <h1>{item.title || "Save The Date"}</h1>
          {primaryDate && <p className="std-public-date">{primaryDate}</p>}
          {locationText ? (
            <p className="std-public-location">
              <LocationOnOutlinedIcon fontSize="small" />
              <span>{locationText}</span>
            </p>
          ) : null}
          {item.message ? <p className="std-public-message">{item.message}</p> : null}
          {!isSignedIn ? (
            <Button
              component="a"
              href={calendarIcsUrl}
              variant="contained"
              className="std-calendar-btn"
            >
              Add to Calendar
            </Button>
          ) : null}
        </div>
      </section>

      <section className="std-public-footer-image">
        {footerImage ? (
          <img src={footerImage} alt={`${item.title || "Save The Date"} footer`} />
        ) : null}
      </section>
    </div>
  );
};

export default SaveTheDatePublicPage;
